import { render } from "./tips.vue?vue&type=template&id=80befeee&scoped=true"
import script from "./tips.vue?vue&type=script&lang=js"
export * from "./tips.vue?vue&type=script&lang=js"

import "./tips.vue?vue&type=style&index=0&id=80befeee&scoped=true&lang=scss"

import exportComponent from "E:\\RedCigar\\Vue\\RedCigar_C_T_Template\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80befeee"]])

export default __exports__